export const permanentDeleteMessageCopy = {
  header: '',
  headerSingle: '',
  descriptionInfo: '',
  warning: '',
  confirmBtnText: '',
  successToast: '',
  successToastSingle: '',
};
